import React, { FC, MouseEvent } from 'react';

import { styled } from '@mui/material';

import useTenantTranslation from '~/hooks/useTenantTranslation';
import { PlansDuration } from '~/pages/PricePage/types';
import { SMALL_MARGIN_PX } from '~/theme';
import { Tag } from '~/ui/components/Tag/Tag';
import {
  ToggleButton,
  ToggleButtonGroup,
} from '~/ui/components/ToggleButtonGroup/ToggleButtonGroup';

interface DurationToggleButtonGroupProps {
  duration: PlansDuration;
  onDurationChange?: (duration: PlansDuration) => void;
}

const DurationToggleButtonGroup: FC<DurationToggleButtonGroupProps> = ({
  duration = 'annual',
  onDurationChange,
}) => {
  const { t } = useTenantTranslation();

  function handleDurationChange(_: MouseEvent<HTMLElement>, newDuration: PlansDuration) {
    onDurationChange?.(newDuration);
  }

  return (
    <StyledContainer data-testid="DurationToggleButton">
      <ToggleButtonGroup
        aria-label="Duration toggle"
        exclusive={true}
        value={duration}
        onChange={handleDurationChange}
      >
        <ToggleButton aria-label="Monthly plans" value={'monthly'}>
          {t('page.price.billedMonthly')}
        </ToggleButton>
        <ToggleButton aria-label="Annual plans" value={'annual'}>
          {t('page.price.billedAnnually')}
        </ToggleButton>
      </ToggleButtonGroup>
      <StyledDiscountTag>{t('common.save20')}</StyledDiscountTag>
    </StyledContainer>
  );
};

export default DurationToggleButtonGroup;

const StyledContainer = styled('div')`
  display: flex;
  position: relative;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: inline-flex;
  }
`;
const StyledDiscountTag = styled(Tag)`
  display: none;

  position: absolute;
  right: 0;
  top: -${SMALL_MARGIN_PX};

  ${({ theme }) => theme.breakpoints.up('md')} {
    display: block;
  }
`;
